import React from 'react';

import LotteriesApi from '../../../Api/CRM/Modules/LotteriesApi';
import Lottery from '../../../Api/Models/Lottery';
import useGlobalState from '../../GlobalStateContext';
import confirmationAlert from '../../elements/alerts/confirmationAlert';

export default function LotteryToggleButton({ lottery, onUpdate }: { lottery: Lottery; onUpdate: Function }) {
    const { loggedAdmin } = useGlobalState();

    function handleButtonClick() {
        if (lottery.is_enabled) {
            confirmationAlert({
                title: 'Disable Lottery',
                text: 'Are you sure you want to disable this lottery?',
                onConfirm: () => LotteriesApi.setEnable(lottery.display_slug, false).then(() => onUpdate()),
            });
        } else {
            LotteriesApi.setEnable(lottery.display_slug, true).then(() => onUpdate());
        }
    }

    return loggedAdmin.isSuperAdmin() ? (
        <button
            type="button"
            className={`btn btn-${lottery.is_enabled ? 'danger' : 'secondary'} btn-sm mb-3`}
            disabled={lottery.is_default || !lottery.is_enabled}
            onClick={handleButtonClick}
        >
            {lottery.is_enabled ? 'Disable' : 'Enable'}
        </button>
    ) : null;
}
